
define('text!templates/parts/fetch-button.html',[],function () { return '<button class="fetch-button white-box btn btn-block btn-md {{ class }}"><span class="{{icon}}"></span> {{#t}}{{ label }}{{/t}}<span class="sr-only"> {{#t}}Loading{{/t}}...</span></button>\n';});

